export default __webpack_public_path__ + "static/media/Billing-Address.576eef32.jpg";